// extracted by mini-css-extract-plugin
export default {"fallback-stacks-modal":"styles_fallback-stacks-modal__6fMXB"};